import { memo } from "react";
import * as Styled from "./style";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { useAuth } from "~/provider/auth";

type Props = {
  name: string;
};

export const MenuButtonForAuth = memo((props: Props) => {
  const { name } = props;
  const { handleClickByDevice } = useHandleClickByDevice();
  const { execAuth } = useAuth();

  return (
    <Styled.ButtonItem type="button" name="navigateLogin" aria-label="navigateLogin" {...handleClickByDevice(execAuth)}>
      {name}
    </Styled.ButtonItem>
  );
});

MenuButtonForAuth.displayName = "MenuItemForAuth";
